import { useMemo } from 'react';
import { isNil, omitBy } from 'lodash';

import { EMPTY_STRING } from '@e-socna/empty';
import type { MutationLoginArgs } from '@e-socna/data-layer';

export const useInitialValuesFactory = (pInitialValues?: MutationLoginArgs) => {
  const initialValues: MutationLoginArgs = useMemo(
    () => ({
      email: EMPTY_STRING,
      password: EMPTY_STRING,
      ...omitBy(pInitialValues, isNil),
    }),
    [pInitialValues],
  );

  return { initialValues };
};
